// https://www.modularscale.com/?14,18&px&1.618
/* eslint-disable import/no-unused-modules */ export var SCALE_NEG_4 = "4px";
export var SCALE_NEG_3 = "8px";
export var SCALE_NEG_2 = "12px";
export var SCALE_NEG_1 = "14px";
export var SCALE_0 = "18px";
export var SCALE_1 = "23px";
export var SCALE_2 = "30px";
export var SCALE_3 = "37px";
export var SCALE_4 = "47px";
export var SCALE_5 = "60px";
export var SCALE_6 = "76px";
export var SCALE_7 = "96px";
export var SCALE_8 = "123px";
export var SCALE_9 = "155px";
export var SCALE_10 = "200px";
export var SCALE_11 = "251px";
export var SCALE_12 = "322px";
export var SCALE_13 = "406px";
export var SCALE_14 = "522px";
export var SCALE_15 = "657px";
